import React from 'react';
import { getCarriers } from '../../api';
import GenericAssigner from './GenericAssigner';

const CarrierAssigner = ({
  order,
  onCarrierChange,
  carriers: parentCarriers,
  multiSelect = false,
  selectedOrderIds = []
}) => {
  const fetchCarriersWrapper = async () => {
    return await getCarriers(false);
  };

  return (
    <GenericAssigner
      order={order}
      onChange={onCarrierChange}
      multiSelect={multiSelect}
      selectedOrderIds={selectedOrderIds}
      preChargedOptions={parentCarriers}
      fetchOptions={fetchCarriersWrapper}
      fieldName="carrierId"
      displayField="firstName"
      valueField="id"
    />
  );
};

export default CarrierAssigner;
